// User group: User (ผู้ใช้) vs Staff (เจ้าหน้าที่) — ใช้แทน mock USER_TYPES
export const USER_GROUP = {
  USER: 'user',
  STAFF: 'staff',
};

